import { AbstractEntity } from "../AbstractEntity";
export default class ISMRelevantChecklist extends AbstractEntity {
    name;
    constructor(name) {
        super();
        this.name = name;
    }
}
//# sourceMappingURL=ISMRelevantChecklist.js.map